import { CapoPlugin } from "/home/josed/Documents/CODE/relowcode/app/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];